<template>
  <div class="pw-searchbar">
    <div class="search-area">
      <i class="mdi mdi-magnify" />
      <Treeselect
        class="custom-treeselect"
        :openOnClick="false"
        :matchKeys="['label', 'PersonalCode']"
        :loadOptions="loadOptions"
        loadingText="Buscando..."
        noOptionsText="No hay datos disponibles."
        noResultsText="No se encontraron resultados."
        searchPromptText="Introduce algún criterio de búsqueda"
        openDirection="below"
        v-on="$listeners"
        v-bind="$attrs"
        ref="searchbar"
      >
        <slot
          name="option-label"
          slot="option-label"
          slot-scope="{ node, labelClassName }"
          :node="node"
          :labelClassName="labelClassName"
        ></slot>
      </Treeselect>
    </div>
  </div>
</template>

<script>
import Treeselect, { ASYNC_SEARCH } from '@riophae/vue-treeselect';

// import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'SearchBar',
  components: {
    Treeselect,
  },
  data() {
    return {
      timeout: null,
      value: null,
    };
  },
  methods: {
    loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        this.$emit('searchQueryAsync', { searchQuery, callback });
      }
    },
  },
};
</script>

<style lang="scss">
.pw-searchbar {
  position: relative;
  width: 350px;
  .search-area {
    background-color: #f2f5f8;
    padding: 0 4px;
    height: 32px;
    box-sizing: border-box;
    border: 1px solid #d5dbf3;
    border-radius: 3px;
    display: flex;
    align-items: center;
    .mdi {
      font-size: 24px;
      align-self: baseline;
      color: #89959e;
    }
    &:focus-within {
      border-color: #4571d8;
    }
  }
}
.custom-treeselect {
  border: 0px;
  background: transparent;
  .vue-treeselect {
    &:focus {
      outline: 0 !important;
    }
    &__control {
      padding-top: 3px;
      font-size: 16px;
      padding-left: 2px;
      padding-right: 5px;
      height: 32px;
      width: 100%;
      box-sizing: border-box;
      outline: none;
      background: transparent;
      border: 0px;
      font-family: 'Nunito Sans', sans-serif;

      &:focus {
        outline: 0 !important;
      }
      &-arrow-container {
        display: none;
      }
    }
    &__placeholder {
      color: #89959e;
      text-transform: none;
    }
  }
  .vue-treeselect__label {
    color: #333;
    font-size: 14px;
    line-height: 1.36;
    padding: 7px 8px;
  }
}
.vue-treeselect--focused:not(.vue-treeselect--open) .vue-treeselect__control {
  box-shadow: none;
}
</style>
